import * as React from "react";
import {NewsGridItem} from '../../component/news/NewsGridItem';
import {NewsLastPost} from '../../component/news/NewsLastPost';
import {Footer} from '../../component/layout/Footer';
import {Navigation} from '../../component/layout/Navigation';
import {PostApiService} from "../../core/api/post/PostApiService";
import {IReadNewsResponse} from "../../core/api/post/response/ReadNewsResponse";

interface IProps {
    componentName?: string;
}

interface IState{
    newsData: IReadNewsResponse[] | undefined;
}

export class News extends React.Component<IProps, IState> {

    private readonly postService = new PostApiService();

    constructor(props: IProps) {
        super(props);

        this.state = {
            newsData: undefined
        }
    }

    public componentDidMount = () =>{
        this.fetchData();
    };

    public render() {
        return (
            <div id="news-page" className="page client-area">
                <Navigation navClass="main-nav js-stick" />

                <section className="page-section bg-dark-alfa-30 parallax-3 news-header-section">
                    <div className="relative container align-left">
                        <div className="row">
                            <div className="col-md-8">
                                <h1 className="hs-line-11 font-alt mb-20 mb-xs-0">Berita</h1>
                                <div className="hs-line-4 font-alt black">Berita terbaru seputar Desa Sanur Kauh</div>
                            </div>
                            <div className="col-md-4 mt-30">
                                <div className="mod-breadcrumbs font-alt align-right"><a
                                    href="/">Beranda</a>&nbsp;/&nbsp;Berita</div>
                            </div>
                        </div>
                    </div>
                </section>
                <section className="page-section">
                    <div className="container relative">
                        <div className="row">
                            <div className="col-sm-8">

                                {this.state.newsData === undefined ? <p>Loading...</p> : (
                                    <div>
                                        {this.state.newsData.length < 1 ? <p>Tidak ada berita.</p> : this.state.newsData.map((item, index) =>
                                            <NewsGridItem key={index} data={item}  />
                                        )}
                                    </div>
                                )}

                                {/*<div className="pagination">
                                    <a className="active" href="blog-classic-sidebar-right.html">1</a>
                                    <a href="blog-classic-sidebar-right.html">2</a>
                                    <a href="blog-classic-sidebar-right.html">3</a>
                                    <a className="no-active">...</a>
                                    <a href="blog-classic-sidebar-right.html">9</a>
                                </div>*/}

                            </div>

                            <div className="col-sm-4 col-md-3 col-md-offset-1 sidebar">
                                <div className="widget">
                                    <form className="form-inline form">
                                        <div className="search-wrap"><button className="search-button animate" title="Start Search"
                                            type="submit" /><input className="form-control search-field" type="text"
                                                placeholder="Search..." /></div>
                                    </form>
                                </div>

                                <NewsLastPost />

                            </div>
                        </div>
                    </div>
                </section>
                <Footer />
            </div>
        );
    }

    private fetchData = () => {
        this.postService.getNews(0)
            .then((response: any) => {
                this.setState({
                    newsData: response.result
                })
            }).catch((error) => {
            this.setState({
                newsData: []
            })
        })
    }
}


// WEBPACK FOOTER //
// ./src/screen/news/News.tsx